import { SET_USER_DATA, SET_USER_PREFERENCE } from './actionTypes';

import { User, Preference, UserAction } from '../reducers/user';

export const setUserData = (data: User | null): UserAction => ({ type: SET_USER_DATA, data });

export const setUserPreference = (preference: Preference): UserAction => ({ type: SET_USER_PREFERENCE, preference });
